export class Controller {

    /** @ngInject */
    constructor(UserLabelsService,Alert) {
        this.UserLabelsService = UserLabelsService;
		this.Alert=Alert;
    }

    $onInit() {
    }

    delete() {
        this.isSaving = true;
		const companyId=this.resolve.companyId;
		const labelId = this.resolve.labelId;
		this.UserLabelsService.deleteLabel({companyId,labelId}).$promise
		.then(()=> {this.close();})
		.catch((error)=>{this.spAlert = new SpAlert('danger', error.data.message);})
		.finally(()=>{this.isSaving=false;});
       
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/label-settings/delete/delete-label.controller.js